import NonReduxEditablePercent from 'components/Base/EditablePercent/NonReduxEditablePercent';
import { isObject } from 'lodash';
import React from 'react';
import { unFormatPercent } from 'utils';
import { RiskOrReturnEnum } from 'utils/riskOrReturn';
import { timeHorizonEnum } from 'utils/timeHorizon';

type ForecaseReturnInputsProps = {
  riskLevelDescriptions: any[];
  title: string;
  onChange: Function;
  initValues: any;
  defaultRiskAndReturn: any;
  timeHorizonEnumVal: timeHorizonEnum | null;
  isFirmAdmin: boolean;
  isCustom: boolean;
};

const ForecaseReturnInputs: React.FC<ForecaseReturnInputsProps> = ({
  riskLevelDescriptions,
  title,
  onChange,
  initValues,
  defaultRiskAndReturn,
  timeHorizonEnumVal,
  isFirmAdmin,
  isCustom
}) => {
  const getValue = (config: any, rld: any) => {
    const base = config[rld.risk_level];
    if (isObject(base)) {
      return (base as any)[title.toLowerCase()];
    } else {
      return base;
    }
  };

  return (
    <div className="forecastReturnsConfigContainer">
      <div
        className="riskLevelInput"
        style={{
          width: `calc(100% / ${riskLevelDescriptions.length + 1})`,
          fontWeight: 'bold'
        }}
      >
        <div>{title}</div>
      </div>
      {riskLevelDescriptions.map((rld: any) => {
        return (
          <div
            key={`${rld.risk_level}`}
            className="riskLevelInput"
            style={{
              width: `calc(100% / ${riskLevelDescriptions.length + 1})`,
              border: '1px solid lightgray',
              backgroundColor: 'rgb(238, 238, 238)'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <NonReduxEditablePercent
                name={`${rld.risk_level}.${title.toLowerCase()}`}
                defaultValue={getValue(defaultRiskAndReturn, rld)}
                value={
                  getValue(initValues, rld) !==
                  getValue(defaultRiskAndReturn, rld)
                    ? getValue(initValues, rld)
                    : null
                }
                onChange={(e: any) => {
                  onChange(
                    timeHorizonEnumVal,
                    rld.risk_level,
                    unFormatPercent(e),
                    title === 'Return'
                      ? RiskOrReturnEnum.RETURN
                      : RiskOrReturnEnum.RISK
                  );
                }}
                isEditable={isFirmAdmin && isCustom}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ForecaseReturnInputs;
